/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Page } from '../../models/page';

export interface ApiMasterPageGetPageByMenuIdGet$Params {
  id?: number;
}

export function apiMasterPageGetPageByMenuIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterPageGetPageByMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Page>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPageGetPageByMenuIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Page>;
    })
  );
}

apiMasterPageGetPageByMenuIdGet.PATH = '/api/Master/Page/GetPageByMenuId';
